"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiService = void 0;
var config_1 = require("../config");
var $ = require("jquery");
/**
 * Servicio centralizado para todas las llamadas HTTP a la API pública de Wattwin.
 *
 * Host:   config.publicApiHost   (ej. https://public.api.wattwin.com/v1)
 * Auth:   header x-api-key
 *
 * Excepción: getEstimatedSavings sigue en API legacy (pendiente de migrar).
 *
 * Docs API pública: https://wattwin.readme.io/reference
 */
var ApiService = /** @class */ (function () {
    function ApiService() {
    }
    // ---------------------------------------------------------------------------
    //  Helpers HTTP genéricos — API pública
    // ---------------------------------------------------------------------------
    /**
     * GET a la API pública con filtro LoopBack serializado en query string.
     */
    ApiService.getPublic = function (url, filter) {
        return new Promise(function (resolve, reject) {
            var query = filter ? '?filter=' + encodeURIComponent(JSON.stringify(filter)) : '';
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url + query, true);
            xhr.setRequestHeader('x-api-key', config_1.config.apiKey);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.responseText));
                    }
                    else {
                        reject(new Error("GET " + url + " failed with status " + xhr.status));
                    }
                }
            };
            xhr.send();
        });
    };
    /**
     * GET a la API pública con parámetros jQuery (no filter LoopBack).
     * Útil para endpoints que reciben parámetros planos (ej. estimated-savings).
     */
    ApiService.getPublicWithParams = function (url, params) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                headers: { 'x-api-key': config_1.config.apiKey },
                data: params,
                success: function (response) { return resolve(response); },
                error: function (xhr) { return reject(new Error("GET " + url + " failed with status " + xhr.status)); }
            });
        });
    };
    /**
     * POST a la API pública con cuerpo JSON.
     */
    ApiService.postPublic = function (url, body) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: url,
                type: 'POST',
                dataType: 'json',
                headers: { 'x-api-key': config_1.config.apiKey },
                data: JSON.stringify(body),
                contentType: 'application/json',
                success: function (response) { return resolve(response); },
                error: function (xhr) { return reject(new Error("POST " + url + " failed with status " + xhr.status)); }
            });
        });
    };
    /**
     * PATCH a la API pública con cuerpo JSON.
     */
    ApiService.patchPublic = function (url, body) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: url,
                type: 'PATCH',
                dataType: 'json',
                headers: { 'x-api-key': config_1.config.apiKey },
                data: JSON.stringify(body),
                contentType: 'application/json',
                success: function (response) { return resolve(response); },
                error: function (xhr) { return reject(new Error("PATCH " + url + " failed with status " + xhr.status)); }
            });
        });
    };
    /**
     * POST multipart a la API pública (para subida de documentos).
     */
    ApiService.postPublicFormData = function (url, formData) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: url,
                type: 'POST',
                headers: { 'x-api-key': config_1.config.apiKey },
                processData: false,
                data: formData,
                contentType: false,
                success: function (response) { return resolve(response); },
                error: function (xhr) { return reject(new Error("POST " + url + " failed with status " + xhr.status)); }
            });
        });
    };
    // ---------------------------------------------------------------------------
    //  Endpoints específicos — API pública de Wattwin
    // ---------------------------------------------------------------------------
    /**
     * GET /ConsumptionProfiles
     * Obtiene el perfil de consumo por defecto según dominio y código.
     * Sustituye legacy GET /ConsumptionProfiles/findOne + access_token.
     * @see https://wattwin.readme.io/reference/get_consumptionprofiles
     */
    ApiService.getConsumptionProfile = function (domainId, code) {
        return __awaiter(this, void 0, void 0, function () {
            var filter, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filter = { where: { domainId: domainId, code: code }, fields: ['id'], limit: 1 };
                        return [4 /*yield*/, ApiService.getPublic(config_1.config.publicApiHost + '/ConsumptionProfiles', filter)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data && data.length ? data[0] : undefined];
                }
            });
        });
    };
    /**
     * POST /ConsumptionProfiles/search
     * Búsqueda de perfiles de consumo (ElasticSearch) filtrada por tipo y dominio.
     * @see https://wattwin.readme.io/reference/post_consumptionprofiles-search
     */
    ApiService.searchConsumptionProfiles = function (domainId, type) {
        return __awaiter(this, void 0, void 0, function () {
            var body;
            return __generator(this, function (_a) {
                body = {
                    fields: ['name'],
                    filters: {
                        bool: {
                            must: [
                                { term: { type: type } },
                                { term: { domainId: domainId } },
                                { term: { statusId: 'PUBLISHED' } }
                            ]
                        }
                    },
                    offset: 0,
                    sort: { order: { order: 'asc' } }
                };
                return [2 /*return*/, ApiService.postPublic(config_1.config.publicApiHost + '/ConsumptionProfiles/search', body)];
            });
        });
    };
    /**
     * GET /Channels
     * Obtiene el canal comercial por código y dominio.
     * Sustituye legacy GET /Channels/findByCode/{code} + access_token.
     * @see https://wattwin.readme.io/reference/get_channels
     */
    ApiService.getChannel = function (domainId, code) {
        return __awaiter(this, void 0, void 0, function () {
            var filter, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filter = { where: { domainId: domainId, code: code }, fields: ['id'], limit: 1 };
                        return [4 /*yield*/, ApiService.getPublic(config_1.config.publicApiHost + '/Channels', filter)];
                    case 1:
                        data = _a.sent();
                        if (!data || !data.length) {
                            throw new Error("Channel not found for code: " + code);
                        }
                        return [2 /*return*/, data[0].id];
                }
            });
        });
    };
    /**
     * GET /Wizards
     * Obtiene el wizard por código y dominio.
     * Sustituye legacy GET /Wizards/findByCode/{code} + access_token.
     * @see https://wattwin.readme.io/reference/get_wizards
     */
    ApiService.getWizard = function (domainId, code) {
        return __awaiter(this, void 0, void 0, function () {
            var filter, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filter = { where: { domainId: domainId, code: code }, fields: ['id'], limit: 1 };
                        return [4 /*yield*/, ApiService.getPublic(config_1.config.publicApiHost + '/Wizards', filter)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data && data.length ? data[0] : undefined];
                }
            });
        });
    };
    /**
     * POST /Wizards/submit
     * Envío final del formulario (crear o actualizar oferta).
     * Sustituye legacy POST|PUT a backendPoint (/Wizards/submit&queue=true) + X-Access-Token.
     * @see https://wattwin.readme.io/reference/wizardssubmit
     */
    ApiService.submitWizard = function (params, method, id, token) {
        if (method === void 0) { method = 'POST'; }
        var url = config_1.config.publicApiHost + '/Wizards/submit?queue=true';
        if (method === 'PUT' && id && token) {
            url = config_1.config.publicApiHost + '/Wizards/submit/' + id + '/' + token + '?queue=true';
        }
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: url,
                type: method,
                dataType: 'json',
                headers: { 'x-api-key': config_1.config.apiKey },
                data: JSON.stringify(params),
                contentType: 'application/json',
                success: resolve,
                error: reject
            });
        });
    };
    /**
     * GET /Solutions
     * Obtiene la solución filtrando por código.
     * @see https://wattwin.readme.io/reference/get_solutions
     */
    ApiService.getSolution = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var filter, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filter = { where: { code: code }, limit: 1 };
                        return [4 /*yield*/, ApiService.getPublic(config_1.config.publicApiHost + '/Solutions', filter)];
                    case 1:
                        data = _a.sent();
                        if (!data || !data.length) {
                            throw new Error("Solution not found for code: " + code);
                        }
                        return [2 /*return*/, data[0]];
                }
            });
        });
    };
    /**
     * GET /Provinces
     * Obtiene la provincia a partir del código postal (primeros 2 dígitos).
     * @see https://wattwin.readme.io/reference/get_provinces
     */
    ApiService.getProvince = function (postalCodePrefix) {
        return __awaiter(this, void 0, void 0, function () {
            var filter, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filter = { where: { id: postalCodePrefix }, fields: ['name'], limit: 1 };
                        return [4 /*yield*/, ApiService.getPublic(config_1.config.publicApiHost + '/Provinces', filter)];
                    case 1:
                        data = _a.sent();
                        if (!data || !data.length) {
                            throw new Error("Province not found for postal code prefix: " + postalCodePrefix);
                        }
                        return [2 /*return*/, data[0].name];
                }
            });
        });
    };
    /**
     * GET /ForecastPlans
     * Obtiene planes de previsión por código de país.
     * Sustituye legacy GET /ForecastPlans + X-Access-Token.
     * @see https://wattwin.readme.io/reference/get_forecastplans
     */
    ApiService.getForecastPlans = function (countryCode) {
        return __awaiter(this, void 0, void 0, function () {
            var filter;
            return __generator(this, function (_a) {
                filter = { where: { code: countryCode }, fields: ['id'] };
                return [2 /*return*/, ApiService.getPublic(config_1.config.publicApiHost + '/ForecastPlans', filter)];
            });
        });
    };
    /**
     * GET /ForecastPlanTariffs
     * Obtiene las tarifas de un plan de previsión, filtradas por nombres válidos.
     * Sustituye legacy GET /ForecastPlanTariffs + X-Access-Token.
     * @see https://wattwin.readme.io/reference/get_forecastplantariffs
     */
    ApiService.getForecastPlanTariffs = function (forecastPlanId, validTariffs) {
        return __awaiter(this, void 0, void 0, function () {
            var filter;
            return __generator(this, function (_a) {
                filter = {
                    order: 'name ASC',
                    where: { and: [{ forecastPlanId: forecastPlanId }, { name: { inq: validTariffs } }, { statusId: 'PUBLISHED' }] }
                };
                return [2 /*return*/, ApiService.getPublic(config_1.config.publicApiHost + '/ForecastPlanTariffs', filter)];
            });
        });
    };
    /**
     * POST /Products/search
     * Busca productos (módulos y estructuras) por referencias y/o id.
     * @see https://wattwin.readme.io/reference/post_products-search
     */
    ApiService.getProducts = function (references, moduleId) {
        return __awaiter(this, void 0, void 0, function () {
            var must, body, data, hits;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        must = [{ term: { statusId: 'PUBLISHED' } }];
                        if (moduleId) {
                            must.push({
                                bool: {
                                    should: [{ terms: { 'reference.keyword': references } }, { term: { id: moduleId } }]
                                }
                            });
                        }
                        else {
                            must.push({ terms: { 'reference.keyword': references } });
                        }
                        body = {
                            fields: ['id', 'reference', 'properties'],
                            filters: { bool: { must: must } },
                            offset: 0,
                            limit: Math.max(references.length + 1, 10)
                        };
                        return [4 /*yield*/, ApiService.postPublic(config_1.config.publicApiHost + '/Products/search', body)];
                    case 1:
                        data = _a.sent();
                        hits = (data && data.hits && data.hits.hits) || [];
                        return [2 /*return*/, hits.map(function (hit) { return hit._source; })];
                }
            });
        });
    };
    /**
     * GET /PowerPlants/estimated-savings (API pública)
     * Calcula los ahorros estimados de la instalación fotovoltaica.
     * @see https://wattwin.readme.io/reference/getestimatedsavings
     */
    ApiService.getEstimatedSavings = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ApiService.getPublicWithParams(config_1.config.publicApiHost + '/PowerPlants/estimated-savings', { channelId: params.channelId, templateCode: params.templateCode, data: JSON.stringify(params.data) }).catch(function () { return undefined; })];
            });
        });
    };
    /**
     * POST /PowerPlants/recommend
     * Calcula la recomendación de instalación óptima.
     * Sustituye legacy POST sin auth (bug).
     * @see https://wattwin.readme.io/reference/post_powerplants-recommend
     */
    ApiService.getRecommendation = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ApiService.postPublic(config_1.config.publicApiHost + '/PowerPlants/recommend', params)];
            });
        });
    };
    /**
     * POST /Products/search — producto por id.
     * @see https://wattwin.readme.io/reference/post_products-search
     */
    ApiService.getProductById = function (productId) {
        return __awaiter(this, void 0, void 0, function () {
            var body, data, hits;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = {
                            fields: ['id', 'reference', 'properties', 'code'],
                            filters: {
                                bool: {
                                    must: [
                                        { term: { statusId: 'PUBLISHED' } },
                                        { term: { id: productId } }
                                    ]
                                }
                            },
                            offset: 0,
                            limit: 1
                        };
                        return [4 /*yield*/, ApiService.postPublic(config_1.config.publicApiHost + '/Products/search', body)];
                    case 1:
                        data = _a.sent();
                        hits = (data && data.hits && data.hits.hits) || [];
                        if (!hits.length) {
                            throw new Error("Product not found for id: " + productId);
                        }
                        return [2 /*return*/, hits[0]._source];
                }
            });
        });
    };
    /**
     * GET /DocumentFolders
     * Obtiene la carpeta de documentos por código y dominio.
     * Sustituye legacy GET /DocumentFolders/findByCode/{code} + access_token.
     * @see https://wattwin.readme.io/reference/get_documentfolders
     */
    ApiService.getDocumentFolder = function (domainId, code) {
        return __awaiter(this, void 0, void 0, function () {
            var filter, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filter = { where: { domainId: domainId, code: code }, fields: ['id'], limit: 1 };
                        return [4 /*yield*/, ApiService.getPublic(config_1.config.publicApiHost + '/DocumentFolders', filter)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data && data.length ? data[0] : undefined];
                }
            });
        });
    };
    /**
     * POST /Documents — upload multipart.
     * @see https://wattwin.readme.io/reference/uploaddocument
     */
    ApiService.uploadDocument = function (formData, onSuccess, onError) {
        ApiService.postPublicFormData(config_1.config.publicApiHost + '/Documents', formData)
            .then(onSuccess)
            .catch(onError);
    };
    /**
     * POST /Wizards/saveApplication
     * @see https://wattwin.readme.io/reference/wizardssaveapplication
     */
    ApiService.saveApplication = function (params, onSuccess, onError) {
        ApiService.postPublic(config_1.config.publicApiHost + '/Wizards/saveApplication', params)
            .then(onSuccess)
            .catch(onError);
    };
    /**
     * GET /ProcessInstances/{id}
     * @see https://wattwin.readme.io/reference/get_processinstances-id
     */
    ApiService.getProcessInstance = function (id) {
        return ApiService.getPublic(config_1.config.publicApiHost + '/ProcessInstances/' + id);
    };
    /**
     * PATCH /ProcessInstances/{id}
     * @see https://wattwin.readme.io/reference/patch_processinstances-id
     */
    ApiService.patchProcessInstance = function (id, body) {
        return ApiService.patchPublic(config_1.config.publicApiHost + '/ProcessInstances/' + id, body);
    };
    return ApiService;
}());
exports.ApiService = ApiService;
